export const messages = {
  "admin_llm_keys.title": "AI models",
  "admin_llm_keys.subtitle":
    "Keys are tried top to bottom. A key that is revoked, out of quota or rate limited hands over to the next.",
  "admin_llm_keys.add": "Add key",
  "admin_llm_keys.empty":
    "No keys saved. The WhatsApp assistant uses the server's environment key, if one is set.",
  "admin_llm_keys.load_failed": "Could not load the AI model keys.",
  "admin_llm_keys.save_failed": "Could not save the key.",
  "admin_llm_keys.field.display_name": "Name",
  "admin_llm_keys.field.provider": "Provider",
  "admin_llm_keys.field.model": "Model",
  "admin_llm_keys.field.base_url": "Base URL",
  "admin_llm_keys.field.base_url.hint": "Optional. Leave blank for the provider's default.",
  "admin_llm_keys.field.api_key": "API key",
  "admin_llm_keys.field.api_key.keep": "Leave blank to keep the current key",
  "admin_llm_keys.provider.anthropic": "Anthropic",
  "admin_llm_keys.provider.openai_compatible": "OpenAI-compatible",
  "admin_llm_keys.key_hint": "Key ending {hint}",
  "admin_llm_keys.usage": "This month: {calls} calls, {input_tokens} in / {output_tokens} out tokens",
  "admin_llm_keys.status.enabled": "Enabled",
  "admin_llm_keys.status.disabled": "Disabled",
  "admin_llm_keys.action.save": "Save key",
  "admin_llm_keys.action.cancel": "Cancel",
  "admin_llm_keys.action.test": "Test",
  "admin_llm_keys.action.edit": "Edit",
  "admin_llm_keys.action.delete": "Delete",
  "admin_llm_keys.action.enable": "Enable",
  "admin_llm_keys.action.disable": "Disable",
  "admin_llm_keys.action.move_up": "Move {name} up",
  "admin_llm_keys.action.move_down": "Move {name} down",
  "admin_llm_keys.test.ok": "The key works.",
  "admin_llm_keys.test.failed": "The provider refused the key: {kind} ({code}).",
  "admin_llm_keys.test.error": "Could not run the test.",
  "admin_llm_keys.confirm.disable.title": "Disable {name}?",
  "admin_llm_keys.confirm.disable.body":
    "It stops being used immediately. The next key in the list takes over.",
  "admin_llm_keys.confirm.delete.title": "Delete {name}?",
  "admin_llm_keys.confirm.delete.body":
    "The encrypted key is removed for good. Its usage history is kept.",
};

export function format(key, values = {}) {
  return messages[key].replace(/\{(\w+)\}/g, (_, name) => values[name] ?? "");
}
